// removed by extract-text-webpack-plugin
module.exports = {"item":"src-components-PpeItemList-PpeItem----PpeItem-module---item---2wri9","title":"src-components-PpeItemList-PpeItem----PpeItem-module---title---3dNoW","description":"src-components-PpeItemList-PpeItem----PpeItem-module---description---2fPPn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PpeItemList/PpeItem/PpeItem.module.scss
// module id = 1193
// module chunks = 137591856104208